import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M3 10v7a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3v-7M3 10l3.79 2.105M3 10v0c0-.604.369-1.146.93-1.368L6.79 7.5M21 10l-3.316 1.842M21 10v0a1.55 1.55 0 0 0-.911-1.412L17.684 7.5m0 0v0a2.5 2.5 0 0 0-2.5-2.5H9.29a2.5 2.5 0 0 0-2.5 2.5v0m10.895 0v4.342M6.79 7.5v4.605m10.895-.263-4.227 2.349a3 3 0 0 1-2.914 0L6.79 12.105M9.158 11h3.79m-3.79-3.5h5.684",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round"
    }, null, -1)
  ])))
}
export default { render: render }